import { render, staticRenderFns } from "./OrdinaryTable.vue?vue&type=template&id=b6339f0a&"
import script from "./OrdinaryTable.vue?vue&type=script&lang=js&"
export * from "./OrdinaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports